<template>
  <div class="w-100 bg-primary py-5 px-3 d-flex justify-content-center welcome-page-wrapper">
    <div class="d-flex flex-column align-items-center form-wrapper">
      <div class="p-4 logo-container w-100 d-flex flex-column align-items-center">
        <img src="@/../public/img/brand/logo_white.svg" alt="Wallkit" height="60" class="mb-1" />
      </div>

      <div v-if="login_form" class="d-flex flex-column align-items-center py-5">
        <h1 class="font-weight-light mb-4 text-center">{{ $t('onboarding.welcome') }}</h1>

        <p class="text-center mb-4">{{ $t('login.title') }}</p>

        <b-form
          @submit.prevent="debounceSubmitLogin"
          class="w-100 form-container"
          novalidate
          ref="formLogin"
          :validated="formValidatedLogin"
        >
          <b-input-group class="position-relative mb-4">
            <b-form-input
              name="email"
              v-model.trim="form.email"
              class="w-100 rounded"
              type="email"
              :placeholder="$t('users.email')"
              autocomplete="email"
              :required="true"
            >
            </b-form-input>
            <div class="invalid-tooltip">
              {{ $t('errors.error_validation') }}
            </div>
          </b-input-group>

          <b-input-group class="position-relative mb-4">
            <b-form-input
              name="password"
              v-model="form.password"
              class="w-100 rounded"
              :type="inputTypeToggled"
              :placeholder="$t('users.password')"
              autocomplete="current-password"
              :required="true"
            >
            </b-form-input>
            <div class="invalid-tooltip">
              {{ $t('form.required_field') }}
            </div>
            <i
              class="fas position-absolute text-white input-icon"
              :class="inputTypeToggled === 'password' ? 'fa-eye' : ' fa-eye-slash'"
              @click="togglePasswordVisibility"
            ></i>
          </b-input-group>

          <b-button class="w-100 font-weight-bold p-2" type="submit">
            {{ $t('login.login') }}
          </b-button>

          <b-button
            variant="link"
            class="text-white align-self-start px-0 pb-0"
            @click="login_form = false"
          >
            {{ $t('login.forgot_password') }}
          </b-button>
          <div>
            <b-button
              variant="link"
              class="text-white align-self-start px-0 pt-0"
              to="/partners-registration"
            >
              {{ $t('login.register_new_partner') }}
            </b-button>
          </div>
        </b-form>
      </div>

      <div v-else class="d-flex flex-column align-items-center py-5">
        <h1 class="font-weight-light mb-4 text-center">{{ $t('login.restore_password') }}</h1>
        <p class="text-center mb-4">{{ $t('login.restore_password_description') }}</p>

        <b-form
          @submit.prevent="debounceSubmitReset"
          class="w-100 form-container"
          novalidate
          ref="formReset"
          :validated="formValidatedReset"
        >
          <b-input-group class="position-relative mb-4">
            <b-form-input
              name="email"
              v-model.trim="reset_email"
              class="w-100 rounded"
              type="email"
              :placeholder="$t('users.email')"
              autocomplete="email"
              :required="true"
            >
            </b-form-input>
            <div class="invalid-tooltip">
              {{ $t('errors.error_validation') }}
            </div>
          </b-input-group>

          <b-button class="w-100 font-weight-bold p-2" type="submit">
            {{ $t('button.send') }}
          </b-button>

          <b-button
            variant="link"
            class="text-white align-self-start px-0"
            @click="login_form = true"
          >
            {{ $t('login.back_to_sign_in') }}
          </b-button>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/utils/axios';

export default {
  name: 'Login',
  middleware: 'no-auth',
  data() {
    return {
      formValidatedLogin: false,
      formValidatedReset: false,
      inputTypeToggled: 'password',
      form: {
        email: '',
        password: '',
      },
      reset_email: '',
      login_form: true,
      debounceSubmitLogin: () => {},
      debounceSubmitReset: () => {},
    };
  },
  created() {
    this.debounceSubmitLogin = _.debounce(this.login, 500);
    this.debounceSubmitReset = _.debounce(this.resetPassword, 500);
  },
  methods: {
    togglePasswordVisibility() {
      if (this.inputTypeToggled === 'password') {
        this.inputTypeToggled = 'text';
      } else {
        this.inputTypeToggled = 'password';
      }
    },
    async login() {
      this.formValidatedLogin = true;

      if (this.$refs.formLogin && this.$refs.formLogin.checkValidity()) {
        try {
          const resp = await this.authorize(this.form);

          if (resp && resp.data && resp.data.token) {
            await this.$store.dispatch('auth/saveToken', { token: resp.data.token });
            await this.$store.dispatch('auth/updateUser', { user: resp.data });
            await this.$store.dispatch('auth/fetchUser');
            await this.$store.dispatch('resource/fetchResources');
            await this.$router.push({ name: 'Home' });
            await this.$store.dispatch('resource/setDefaultResource');
          } else {
            this.formValidatedLogin = false;
            this.form.password = '';
          }
        } catch (err) {
          console.error(err);
        }
      }
    },
    async resetPassword() {
      this.formValidatedReset = true;

      if (this.$refs.formReset.checkValidity()) {
        try {
          await axios
            .post(
              'admin/reset-password',
              { email: this.reset_email },
            )
            .then((resp) => {
              if (resp && resp.data) {
                this.$noty.success(this.$t('login.reset_link_sent'));
              }
            })
            .catch((e) => {
              if (e && e.response) {
                this.$noty.error(e.response.data.error_description);
              }
            });
        } catch (err) {
          console.error(err);
        }
      }
    },
  },
};
</script>
